import request from "@/utils/requestJSON";

export function getArea() {
  return request({
    url: "/storage/RetailStore/Area.json",
    method: "get",
  });
}

export function getLocation() {
  return request({
    url: "/storage/RetailStore/Location.json",
    method: "get",
  });
}
